import { render } from "./MLink.vue?vue&type=template&id=1ff229e4&scoped=true"
import script from "./MLink.vue?vue&type=script&lang=js"
export * from "./MLink.vue?vue&type=script&lang=js"

import "./MLink.vue?vue&type=style&index=0&id=1ff229e4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff229e4"]])

export default __exports__